export default {
  "wt-accordion__container": "_wt-accordion__container_xjarsf_1",
  "wt-accordion-item": "_wt-accordion-item_xjarsf_5",
  "wt-accordion-item__title": "_wt-accordion-item__title_xjarsf_10",
  "wt-accordion-item__trigger": "_wt-accordion-item__trigger_xjarsf_11",
  "wt-accordion-item__icon": "_wt-accordion-item__icon_xjarsf_12",
  "wt-accordion-item__content-container": "_wt-accordion-item__content-container_xjarsf_13",
  "wt-accordion-item__content": "_wt-accordion-item__content_xjarsf_13",
  "wt-accordion-item_closed": "_wt-accordion-item_closed_xjarsf_45",
  "wt-accordion-item_open": "_wt-accordion-item_open_xjarsf_46",
  "wt-accordion-item_heavy": "_wt-accordion-item_heavy_xjarsf_50",
  "wt-accordion-item_theme_dark": "_wt-accordion-item_theme_dark_xjarsf_64",
  "wt-accordion-item__icon_open": "_wt-accordion-item__icon_open_xjarsf_100",
  "wt-accordion-item_size_s": "_wt-accordion-item_size_s_xjarsf_109",
  "wt-accordion-item_size_m": "_wt-accordion-item_size_m_xjarsf_131",
  "wt-accordion-item_size_l": "_wt-accordion-item_size_l_xjarsf_153"
};